export const localeSortByKey = (key, locale?) => {
  let sortOrder = 1;
  let sortKey = key;

  if (key[0] === '-') {
    sortOrder = -1;
    sortKey = key.substring(1);
  }

  const collator = Intl.Collator(locale);

  return (a, b) => {
    if (sortOrder === -1) {
      return collator.compare(b[sortKey], a[sortKey]);
    } else {
      return collator.compare(a[sortKey], b[sortKey]);
    }
  };
};
